import { RouteConfig } from 'vue-router';

export default [
  /**
   * 额度管理
   */
  {
    path: '/credit-limit',
    redirect: '/assessment/audit-pass',
    // meta: {
    //   title: '我的额度',
    //   background: '#F5F6FA',
    //   customNavBar: true,
    //   excludeTracking: true,
    // },
    // component: () => import('@/views/credit-limit/home/index.vue'),
  },

  /**
   * 额度管理
   * 提额中心
   */
  {
    path: '/credit-limit/center',
    meta: {
      title: '提额降息',
      customNavBar: true,
      background: '#F8F9FF',
      excludeTracking: true,
    },
    component: () => import('@/views/credit-limit/home/center.vue'),
  },

  {
    path: '/credit-limit/guide',
    meta: {
      background: '#F5F5F5',
      customNavBar: true,
      title: '提额指南',
    },
    component: () => import('@/views/credit-limit/home/guide.vue'),
  },
  /**
   * 提额-企业主一键提额落地页
   */
  {
    path: '/credit-limit/business-owner/add-amount',
    meta: {
      title: '企业主提额',
      background: '#F5F6FA',
      customNavBar: true,
      excludeTracking: true,
    },
    component: () => import('@/views/credit-limit/business-owner/quick-add-amount.vue'),
  },
  /**
   * 提额-企业主一键提额评估结果页
   */
  {
    path: '/credit-limit/business-owner/assessment',
    meta: {
      title: '评估中',
      background: '#f6f7fb',
      customNavBar: true,
      excludeTracking: true,
    },
    component: () => import('@/views/credit-limit/business-owner/assessment.vue'),
  },
  /**
   * 提额-补充资料
   */
  {
    path: '/credit-limit/information',
    meta: {
      title: '借款',
      background: '#f5f6fa',
      customNavBar: true,
      excludeTracking: true,
    },
    component: () => import('@/views/credit-limit/informatation.vue'),
  },
  /**
   * 提额-小小微税票提额
   */
  {
    path: '/credit-limit/tax',
    meta: {
      title: '税票提额',
      background: '#f5f6fa',
      customNavBar: true,
      excludeTracking: true,
    },
    component: () => import('@/views/credit-limit/tax/index.vue'),
  },
  /**
   * 提额-小小微税票提额
   */
  {
    path: '/credit-limit/tax/authorize-result',
    meta: {
      title: '税票提额',
      background: '#f5f6fa',
      customNavBar: true,
      excludeTracking: true,
    },
    component: () => import('@/views/credit-limit/tax/authorize-result.vue'),
  },
  /**
   * 提额-学历一键提额结果提额
   */
  {
    path: '/credit-limit/education/authorize-result',
    meta: {
      title: '评估中',
      background: '#f5f6fa',
      customNavBar: true,
      excludeTracking: true,
    },
    component: () => import('@/views/credit-limit/education-authorize-result.vue'),
  },
  /**
   * 提额-发票提额-落地页
   */
  {
    path: '/credit-limit/invoice',
    meta: {
      title: '发票提额',
      background: '#F5F6FA',
      customNavBar: true,
      excludeTracking: true,
    },
    component: () => import('@/views/credit-limit/invoice/index.vue'),
  },
  /**
   * 提额-发票提额-图片上传页
   */
  {
    path: '/credit-limit/invoice/upload',
    meta: {
      title: '发票提额',
      background: '#F5F6FA',
      customNavBar: true,
    },
    component: () => import('@/views/credit-limit/invoice/upload.vue'),
  },
  /**
   * 提额-发票提额-结果评估页
   */
  {
    path: '/credit-limit/invoice/authorize-result',
    meta: {
      title: '发票提额',
      background: '#f5f6fa',
      customNavBar: true,
      excludeTracking: true,
    },
    component: () => import('@/views/credit-limit/invoice/authorize-result.vue'),
  },
  /**
   * 提额-专利提额
   */
  {
    path: '/credit-limit/patent',
    meta: {
      title: '专利提额',
      background: '#f5f6fa',
      customNavBar: true,
      excludeTracking: true,
    },
    component: () => import('@/views/credit-limit/patent/index.vue'),
  },
  /**
   * 提额-专利提额
   */
  {
    path: '/credit-limit/patent/result',
    meta: {
      title: '专利提额',
      background: '#f5f6fa',
      customNavBar: true,
      excludeTracking: true,
    },
    component: () => import('@/views/credit-limit/patent/result.vue'),
  },
  /**
   * 提额-个人车辆提额
   */
  {
    path: '/credit-limit/personal-car',
    meta: {
      title: '个人车辆提额',
      background: '#f5f6fa',
      customNavBar: true,
      excludeTracking: true,
    },
    component: () => import('@/views/credit-limit/personal-car/index.vue'),
  },
  /**
   * 提额-个人车辆提额
   */
  {
    path: '/credit-limit/personal-car/result',
    meta: {
      title: '个人车辆提额',
      background: '#f5f6fa',
      customNavBar: true,
      excludeTracking: true,
    },
    component: () => import('@/views/credit-limit/personal-car/result.vue'),
  },
  /**
   * 提额-招投标提额
   */
  {
    path: '/credit-limit/bidding',
    meta: {
      title: '招投标提额',
      background: '#f5f6fa',
      customNavBar: true,
      excludeTracking: true,
    },
    component: () => import('@/views/credit-limit/bidding/index.vue'),
  },
  /**
   * 提额-招投标提额
   */
  {
    path: '/credit-limit/bidding/result',
    meta: {
      title: '招投标提额',
      background: '#f5f6fa',
      customNavBar: true,
      excludeTracking: true,
    },
    component: () => import('@/views/credit-limit/bidding/result.vue'),
  },
  /**
   * 提额-个体工商户提额
   */
  {
    path: '/credit-limit/individual-business',
    meta: {
      title: '商户认证提额',
      background: '#f5f6fa',
      customNavBar: true,
      excludeTracking: true,
    },
    component: () => import('@/views/credit-limit/individual-business/index.vue'),
  },
  /**
   * 提额-个体工商户提额
   */
  {
    path: '/credit-limit/individual-business/authorize-result',
    meta: {
      title: '商户认证提额',
      background: '#f5f6fa',
      customNavBar: true,
      excludeTracking: true,
    },
    component: () => import('@/views/credit-limit/individual-business/authorize-result.vue'),
  },
  /**
   * 提额-商标提额
   */
  {
    path: '/credit-limit/trademark',
    meta: {
      title: '商标提额',
      background: '#f5f6fa',
      customNavBar: true,
      excludeTracking: true,
    },
    component: () => import('@/views/credit-limit/trademark/index.vue'),
  },
  /**
   * 提额-商标提额
   */
  {
    path: '/credit-limit/trademark/result',
    meta: {
      title: '商标提额',
      background: '#f5f6fa',
      customNavBar: true,
      excludeTracking: true,
    },
    component: () => import('@/views/credit-limit/trademark/result.vue'),
  },
  /**
   * 提额-海关进出口提额
   */
  {
    path: '/credit-limit/customs',
    meta: {
      title: '海关进出口提额',
      background: '#f5f6fa',
      customNavBar: true,
      excludeTracking: true,
    },
    component: () => import('@/views/credit-limit/customs/index.vue'),
  },
  /**
   * 提额-海关进出口提额
   */
  {
    path: '/credit-limit/customs/result',
    meta: {
      title: '海关进出口提额',
      background: '#f5f6fa',
      customNavBar: true,
      excludeTracking: true,
    },
    component: () => import('@/views/credit-limit/customs/result.vue'),
  },
  /**
   * 提额-著作权提额
   */
  {
    path: '/credit-limit/copyright',
    meta: {
      title: '著作权提额',
      background: '#f5f6fa',
      customNavBar: true,
      excludeTracking: true,
    },
    component: () => import('@/views/credit-limit/copyright/index.vue'),
  },
  /**
   * 提额-著作权提额
   */
  {
    path: '/credit-limit/copyright/result',
    meta: {
      title: '著作权提额',
      background: '#f5f6fa',
      customNavBar: true,
      excludeTracking: true,
    },
    component: () => import('@/views/credit-limit/copyright/result.vue'),
  },
  /**
   * 提额-电商商户提额
   */
  {
    path: '/credit-limit/online-shopping',
    meta: {
      title: '电商商户提额',
      background: '#f5f6fa',
      customNavBar: true,
      excludeTracking: true,
    },
    component: () => import('@/views/credit-limit/online-shopping/index.vue'),
  },
  /**
   * 提额-电商商户提额
   */
  {
    path: '/credit-limit/online-shopping/authorize-result',
    meta: {
      title: '电商商户提额',
      background: '#f5f6fa',
      customNavBar: true,
      excludeTracking: true,
    },
    component: () => import('@/views/credit-limit/online-shopping/authorize-result.vue'),
  },
  /**
   * 提额-优享提额
   */
  {
    path: '/credit-limit/preferred',
    meta: {
      title: '优享提额',
      background: '#f5f6fa',
      customNavBar: true,
      excludeTracking: true,
    },
    component: () => import('@/views/credit-limit/preferred/index.vue'),
  },
  /**
   * 提额-优享提额
   */
  {
    path: '/credit-limit/preferred/result',
    meta: {
      title: '评估中',
      background: '#f5f6fa',
      customNavBar: true,
      excludeTracking: true,
    },
    component: () => import('@/views/credit-limit/preferred/result.vue'),
  },
  /**
   * 提额-联系人提额
   */
  {
    path: '/credit-limit/contacts',
    meta: {
      title: '联系人提额',
      background: '#f5f6fa',
      customNavBar: true,
      excludeTracking: true,
    },
    component: () => import('@/views/credit-limit/contacts/index.vue'),
  },
] as RouteConfig[];
